import { TileIndex } from "../../types";

export const NUTS_AND_BOLTS_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 13, 13, 13, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 13, 14, 14, 1, 0, 0, 0, 0, 1],
  [1, 0, 2, 2, 0, 0, 0, 12, 19, 0, 9, 5, 13, 14, 14, 1, 0, 2, 2, 0, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 13, 13, 13, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 1, 16, 16, 1, 1, 1, 1, 1, 0, 1, 0, 3, 3, 0, 1],
  [1, 0, 0, 0, 0, 1, 16, 16, 16, 16, 1, 3, 3, 3, 0, 1, 0, 3, 3, 0, 1],
  [1, 0, 14, 0, 0, 1, 16, 24, 0, 16, 1, 3, 17, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 16, 0, 0, 16, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 16, 16, 16, 16, 1, 2, 2, 2, 15, 1, 0, 0, 0, 0, 1],
  [1, 0, 2, 2, 0, 1, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 2, 2, 0, 1],
  [1, 0, 0, 0, 0, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 0, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
